module.exports = __webpack_public_path__ + "img/S3.5bfc8412.png";